const queue = [];
let current = null;
const listeners = new Set();
const notify = () => {
    listeners.forEach((listener) => listener());
};
const isAlreadyPending = (message) => (current === null || current === void 0 ? void 0 : current.message) === message || queue.some((request) => request.message === message);
export const showAlertPopup = (severity, message) => {
    if (!message || isAlreadyPending(message))
        return;
    const request = { severity, message };
    if (current) {
        queue.push(request);
        return;
    }
    current = request;
    notify();
};
export const dismissAlertPopup = () => {
    var _a;
    current = (_a = queue.shift()) !== null && _a !== void 0 ? _a : null;
    notify();
};
export const subscribeAlertPopup = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
export const getAlertPopupSnapshot = () => current;
